import { useQuery } from "react-query";
import * as ajaxEndpoints from "../../../../api/ajax-endpoints";
import { getData } from "../../../../newApis/dotNetApiMethods";
import { IResponse } from "../../../../interfaces/response";

export interface IUnlockApprovalDetail {
  email: string;
  approvalComment: string;
  initiatedByUserName: string;
  dateInitiated: string;
  approvedByUserName: string;
  transactionReference: string;
  workflowCode: string;
  statusText: string;
  lockReason: string;
  additionalLockDescription: string;
  additionalUnlockDescription: string;
  unlockReason: string;
}

export type TUnlockApprovalsByReferenceQuery = {
  ssoUserId: string;
  transactionReference: string;
};

const getUnlockApprovalsByReference = async (
  query: TUnlockApprovalsByReferenceQuery,
): Promise<IResponse<IUnlockApprovalDetail[]>> => {
  const response = await getData(
    `${ajaxEndpoints.UNLOCK_APPROVALS_BY_REFERENCE}?${new URLSearchParams(query).toString()}`,
  );
  return response.data;
};

export default function useGetUnlockApprovalsByReference(
  query: TUnlockApprovalsByReferenceQuery | null,
) {
  return useQuery<IResponse<IUnlockApprovalDetail[]>, Error>(
    [query, "getUnlockApprovalsByReference"],
    () => getUnlockApprovalsByReference(query!),
    {
      enabled: !!query?.ssoUserId && !!query?.transactionReference,
      refetchOnWindowFocus: false,
    },
  );
}
